<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.grupos"
                    :validations="validations.grupoId"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.subGrupos"
                    label="Sub-grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.subGrupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.prioridades"
                    label="Prioridade"
                    show-default-option
                    text-field="nome"
                    v-model="model.prioridadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-area title="Prestadores">
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        :options="form.prestadoresFornecedores"
                        label="Prestador"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.prestadorFornecedorId"
                        value-field="idRegistro"
                    />
                </rkm-col>

                <rkm-col class="col-auto d-flex justify-content-end">
                    <rkm-button
                        :disabled="!model.prestadorFornecedorId"
                        :label=false
                        @click="addPrestadorFornecedor()"
                        class="buttons"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <Prestadores
                :data="model.prestadoresFornecedores"
                ref="PrestadoresFornecedores"
            />
        </rkm-area>

        <rkm-area title="Causas prováveis">
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Descrição"
                        uppercase
                        v-model="model.causaProvavel"
                    />
                </rkm-col>

                <rkm-col class="col-auto d-flex justify-content-end">
                    <rkm-button
                        :disabled="!model.causaProvavel"
                        :label=false
                        @click="addCausaProvavel()"
                        class="buttons"
                        color="primary"
                    >
                        {{ checkEditCausaProvavel ? 'Alterar' : 'Incluir' }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <CausasProvaveis
                :data="model.causasProvaveis"
                @editCausaProvavel="handleEditCausaProvavel"
                @openModalObservacoes="handleOpenModal"
                ref="causasProvaveis"
            />
        </rkm-area>

        <rkm-area title="Configurações">
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="model.isCusto"
                    >
                        Custo
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col>
                    <rkm-form-checkbox
                        v-model="model.isAgendamentoProgramado"
                    >
                        Programar agendamento
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col>
                    <rkm-form-checkbox
                        v-model="model.isIdentificaOsPrestador"
                    >
                        Identificar OS prestador
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col>
                    <rkm-form-checkbox
                        v-model="model.isIdentificaItensAlmoxarifado"
                    >
                        Identificar itens almoxarifado
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>

            <ModalObrservacoes
                :data="model.causasProvaveis"
                @saveObservacao="saveObservacao"
                ref="ModalOberservacoes"
            />
        </rkm-area>
    </rkm-form>
</template>

<script>

// Components.
import CausasProvaveis from './components/causas-provaveis/List.vue'
import ModalObrservacoes from './components/causas-provaveis/components/Model.vue'
import Prestadores from './components/prestadores/List.vue'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

export default {
    components: { CausasProvaveis, ModalObrservacoes, Prestadores },
    computed: {
        prepareReposiory() {

            if (this.model.isPrestador) {

                return this.repositories.unidadeExecutanteManutencao.fornecedor
            } else {

                return this.repositories.unidadeExecutanteManutencao.unidade
            }
        },
        prepareSearchFields() {

            if (this.model.isPrestador) {

                return [
                    { key: 'fornecedor.nome_fantasia', searchable: true }
                ]
            } else {

                return [
                    { key: 'unidade.nome_fantasia', searchable: true }
                ]
            }
        },
        validations() {

            return {
                nome: { required: true, min: 3, max: 100 },
                grupoId: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            servicoManutencao: this.getConectaSusRepository('cadastro.servicoManutencao'),
        }

        this.load()
    },
    data: () => ({
        checkEditCausaProvavel: false,
        form: null,
        isFornecedorPrestador: false,
        model: null,
        oldCausaProvavel: null,
        previousGrupoId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$nextTick().then(() => {
                this.setLoading()

                if (this.id) {

                    this.repositories.servicoManutencao.edit(this.id)
                        .then(({ data }) => {

                            if (data.model) {

                                this.model = this.clone(data.model)
                                this.form = this.clone(data.form)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

                } else {

                    this.repositories.servicoManutencao.create()
                        .then(({ data }) => {

                            if (data.model) {

                                this.model = this.clone(data.model)
                                this.form = this.clone(data.form)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        handleGrupoChange() {

            if (this.model.grupoId !== this.previousGrupoId) {

                const params = this.model.grupoId;

                this.repositories.servicoManutencao.list({ listar: 'subGrupo', params })
                    .then(response => {

                        this.form.subGrupos = response.data;
                    })
                    .catch(this.handleError);

                if (this.previousGrupoId !== null) {

                    this.model.subGrupoId = null;
                }

                this.previousGrupoId = this.model.grupoId;
            }
        },
        addPrestadorFornecedor() {

            const checkPrestadorFornecedor = this.model.prestadoresFornecedores.find(
                prestadorFornecedor => prestadorFornecedor.idRegistro === this.model.prestadorFornecedorId
            );

            if (checkPrestadorFornecedor) {

                this.showValidationNotification('Prestador já adicionado')
                this.model.prestadorFornecedorId = null
                return
            }

            const prestadorFornecedor = this.form.prestadoresFornecedores.find(
                prestadorFornecedor => prestadorFornecedor.idRegistro === this.model.prestadorFornecedorId
            );

            this.model.prestadoresFornecedores.push(prestadorFornecedor)
            this.model.prestadorFornecedorId = null
        },
        addCausaProvavel() {

            const checkCausaProvavel = this.model.causasProvaveis.find(
                causaProvavel => causaProvavel.nomeCausa === this.model.causaProvavel.trim()
            );

            if (this.checkEditCausaProvavel) {

                const index = this.model.causasProvaveis.indexOf(this.oldCausaProvavel);

                if (index !== -1) {
                    this.model.causasProvaveis[index].nomeCausa = this.model.causaProvavel.trim();
                    this.model.causaProvavel = null;
                    this.checkEditCausaProvavel = false;
                    this.oldCausaProvavel = null;
                }
                return;
            }

            if (checkCausaProvavel) {

                this.showValidationNotification('Causa provável já adicionada')
                this.model.causaProvavel = null
                return
            }

            this.model.causasProvaveis.push({ nomeCausa: this.model.causaProvavel.trim() })
            this.model.causaProvavel = null
        },
        handleEditCausaProvavel(causaProvavel) {

            this.model.causaProvavel = causaProvavel.nomeCausa
            this.checkEditCausaProvavel = true
            this.oldCausaProvavel = causaProvavel
        },
        handleOpenModal(causaProvavel) {

            const index = this.model.causasProvaveis.indexOf(causaProvavel)

            this.$refs.ModalOberservacoes.open(index)
        },
        saveObservacao(data) {

            if (data.id !== -1) {

                this.model.causasProvaveis[data.id].observacao = data.observacao.trim();
            }

        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.servicoManutencao.update(this.id, this.prepareData())
                        : this.repositories.servicoManutencao.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.model);
        },
    },
    mixins: [ repository, stringCase, object, error ],
    mounted() {

        if (this.model) {

            this.previousGrupoId = this.model.grupoId;
        }
    },
    props: {
        id: { type: Number },
    },
    watch: {
        'model.grupoId': function() {

            this.handleGrupoChange();
        },
    }
}
</script>